import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {ScreenService} from './screen.service';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  auth = null;
  internal: any = '';
  user = null;
  sidebar = null;

  // Changes
  storeChanges = {
    auth: new Subject(),
    sidebar: new Subject(),
  };

  constructor(private _screenService: ScreenService) { }

  mutations = {
    setAuth: (value: boolean) => {
      this.auth = value;
    },

    setModerator: (moderator: any) => {
      this.user = moderator;
    },

    setInternal: (internal: any) => {
      this.internal = !!internal;
    },

    setSidebar: (value: boolean) => {
      this.sidebar = value;

      this.storeChanges.sidebar.next(this.sidebar);
    },
  };

  actions = {
    showSidebar: () => {
      this.mutations.setSidebar(true);
    },
    hideSidebar: () => {
      this.mutations.setSidebar(false);
    },
    toggleSidebar: () => {
      this.mutations.setSidebar(!this.sidebar);
    },
    initSidebar: () => {
      this.mutations.setSidebar(this._screenService.up('lg'));
    },
  };

  dispatch(action: string, ...args) {
    this.actions[action](...args);
  }

  commit(mutation: string, changes: string[] | string, ...args) {
    this.mutations[mutation](...args);
  }
}
